import { createStyles, makeStyles } from '@material-ui/core/styles';
import { GREEN } from 'constants/colors';
export default makeStyles(theme => createStyles({
  chooseAddressRoot: {
    display: 'flex',
    width: '100%',
    textAlign: 'left'
  },
  radio: {
    '&$checked': {
      color: GREEN
    }
  },
  checked: {},
  checkboxStyle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
  },
  info: {
    marginLeft: theme.spacing(4),
    fontStyle: 'italic'
  }
}));